/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgLinkCardActive = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 18 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M19 14.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 14.5v-9A2.5 2.5 0 0 1 7.5 3h9A2.5 2.5 0 0 1 19 5.5v9Zm-1 0v-9A1.5 1.5 0 0 0 16.5 4h-9A1.5 1.5 0 0 0 6 5.5v9A1.5 1.5 0 0 0 7.5 16h9a1.5 1.5 0 0 0 1.5-1.5Zm-2-8a.5.5 0 0 1-.41.492L15.5 7h-7a.5.5 0 0 1-.09-.992L8.5 6h7a.5.5 0 0 1 .5.5Zm0 3.5a.5.5 0 0 1-.41.492l-.09.008h-7a.5.5 0 0 1-.09-.992L8.5 9.5h7a.5.5 0 0 1 .5.5Zm0 3.5a.5.5 0 0 1-.41.492L15.5 14h-7a.5.5 0 0 1-.09-.992L8.5 13h7a.5.5 0 0 1 .5.5Z",
        fill: "#2089D9"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M3.598 12.139h5.787v5.787H3.598z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m2.495 20.566-.045.034H7A5.6 5.6 0 1 0 1.4 15v5.6H2c.168 0 .333-.012.495-.034ZM5.75 16.4H5.6V15A1.4 1.4 0 1 1 7 16.4H5.75Z",
        fill: "#2089D9",
        stroke: "#fff",
        strokeWidth: 1.2
    }));
export default SvgLinkCardActive;
